module.exports = __webpack_public_path__ + "img/mini_mp_adapt_autarky_content_bg.e03854a1.png";